import { profileConstants as pc } from 'srcReact/ProfilePage'
import { objectMap } from 'srcReact/helpers/utils'

const initialState = {
  emails_settings: {
    email_list: {
      loading: false,
      loaded: false,
      error: false,
      list: []
    },
    email_validation: {},
    code_verification: {}
  },
  invites: {
    loading: false,
    loaded: false,
    error: false,
    list: []
  }
}
export function profile(state = initialState, action) {
  switch (action.type) {
    case pc.GET_EMAIL_LIST_REQUEST:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            loading: true,
            loaded: false,
            error: false
          }
        }
      }
    case pc.GET_EMAIL_LIST_SUCCESS:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            list: action.response.list ? objectMap(action.response.list, (email) => email, true) : [],
            loading: false,
            loaded: true,
            error: false
          }
        }
      }
    case pc.GET_EMAIL_LIST_FAILURE:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            loading: false,
            loaded: false,
            error: true
          }
        }
      }

    case pc.GET_INVITE_LIST_REQUEST:
      return {
        ...state,
        invites: {
          ...state.invites,
          loading: true,
          loaded: false,
          error: false
        }
      }
    case pc.GET_INVITE_LIST_SUCCESS: {
      return {
        ...state,
        invites: {
          list: action.response.invitations,
          loading: false,
          loaded: true,
          error: false
        }
      }
    }
    case pc.GET_INVITE_LIST_FAILURE:
      return {
        ...state,
        invites: {
          ...state.invites,
          loading: false,
          loaded: false,
          error: true
        }
      }

    case pc.RESPOND_TO_INVITE_REQUEST:
      return {
        ...state,
        invites: {
          ...state.invites,
          loading: false,
          loaded: true,
          error: false,
          list: state.invites.list.map((invite) => {
            if (invite.invitation_id == action.response.invitationId) {
              return { ...invite, onUpdate: true }
            }
            return invite
          })
        }
      }
    case pc.RESPOND_TO_INVITE_SUCCESS: {
      return {
        ...state,
        invites: {
          ...state.invites,
          list: state.invites.list.filter((invite) => invite.invitation_id !== action.response.invitationId)
        }
      }
    }

    case pc.RESPOND_TO_INVITE_FAILURE:
      if (action.response.isWorkplacePage) {
        return {
          ...state,
          invites: {
            ...state.invites,
            list: state.invites.list.filter((invite) => invite.invitation_id !== action.error.invitationId)
          }
        }
      }
      return {
        ...state,
        invites: {
          ...state.invites,
          list: state.invites.list.map((invite) => {
            if (invite.invitation_id == action.error.invitation_id) {
              return { ...invite, onUpdate: false, error: true }
            }
            return invite
          })
        }
      }

    case pc.SET_DEFAULT_EMAIL_REQUEST:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            list: state.emails_settings.email_list.list.map((email) => {
              if (email.resourceKey === action.email.resourceKey) {
                const { ...emailCopy } = email
                return { ...emailCopy, default: true }
              }
              if (email.default == true) {
                const { ...emailCopy } = email
                return { ...emailCopy, default: false, last_default: true }
              }
              return email
            })
          }
        }
      }
    case pc.SET_DEFAULT_EMAIL_SUCCESS:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            list: state.emails_settings.email_list.list.map((email) => {
              if (email.last_default == true) {
                const { ...emailCopy } = email
                return { ...emailCopy, last_default: false }
              }
              return email
            })
          }
        }
      }
    case pc.SET_DEFAULT_EMAIL_FAILURE:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            list: state.emails_settings.email_list.list.map((email) => {
              if (email.resourceKey === action.email.resourceKey) {
                const { ...emailCopy } = email
                return { ...emailCopy, default: action.email.default }
              }
              if (email.last_default == true) {
                const { ...emailCopy } = email
                return { ...emailCopy, default: true, last_default: false }
              }
              return email
            })
          }
        }
      }

    case pc.DELETE_EMAIL_REQUEST:
      return { ...state }
    case pc.DELETE_EMAIL_SUCCESS:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_list: {
            ...state.emails_settings.email_list,
            list: state.emails_settings.email_list.list.filter(
              (email) => email.resourceKey !== action.email.resourceKey
            )
          }
        }
      }
    case pc.DELETE_EMAIL_FAILURE:
      return { ...state }

    case pc.SEND_EMAIL_VALIDATION_CODE_REQUEST:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_validation: { submitting: true },
          code_verification: {}
        }
      }
    case pc.SEND_EMAIL_VALIDATION_CODE_SUCCESS:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_validation: {
            submitted: true,
            hashname: action.response.hashname,
            email: action.response.email
          }
        }
      }
    case pc.SEND_EMAIL_VALIDATION_CODE_FAILURE:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_validation: { error: true }
        }
      }

    case pc.VERIFY_EMAIL_CODE_REQUEST:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          code_verification: { submitting: true }
        }
      }
    case pc.VERIFY_EMAIL_CODE_SUCCESS:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          code_verification: { submitted: true },
          email_validation: {}
        }
      }
    case pc.VERIFY_EMAIL_CODE_FAILURE:
      var can_retry = action.error.hasOwnProperty('can_retry') ? action.error.can_retry : true
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          code_verification: {
            error: true,
            can_retry
          },
          email_validation: can_retry ? { ...state.emails_settings.email_validation } : {}
        }
      }

    case pc.RESET_EMAIL_VALIDATION:
      return {
        ...state,
        emails_settings: {
          ...state.emails_settings,
          email_validation: {},
          code_verification: {}
        }
      }

    default:
      return state
  }
}
